import { LOCAL_STORAGE_KEYS } from "./constant";

export function getRandomQuoteIndex() {
    const randomQuoteIndex = Math.floor(Math.random() * 95);
    window.sessionStorage.setItem(LOCAL_STORAGE_KEYS.randomQuoteIndex, JSON.stringify(randomQuoteIndex));
}
